import { formatByCurrency, formatterConfigDefault } from "@anefi/utils";
import { TextInput } from "artisn-ui-react";
import React, { ChangeEvent, FocusEvent, useEffect, useState } from "react";
import { FieldValues, useController } from "react-hook-form";

import Styles from "./NumberInput.styles";
import { NumberInputProps as Props } from "./NumberInput.types";

const NumberInput = <T extends FieldValues>(props: Props<T>) => {
  const {
    name,
    control,
    defaultValue,
    label,
    maxLength = 15,
    placeholder,
    ...rest
  } = props;
  const { field, fieldState } = useController({
    name,
    control,
    defaultValue
  });
  const { symbol = "$" } = formatterConfigDefault;
  const { value } = field ?? {};
  const valueFormat = formatByCurrency(
    Number(value),
    formatterConfigDefault
  ).replace(symbol, "");
  const [localValue, setLocalValue] = useState<string | undefined>(valueFormat);
  const { onChange, onBlur, ...restField } = field;
  const errorMessage = fieldState?.error?.message;

  const changeHandler = (input: ChangeEvent<HTMLInputElement>) => {
    const text = input.target.value;
    const newValue = text.replace(/[^0-9.]+/g, "");
    setLocalValue(newValue);
    onChange(newValue);
  };

  const blurHandler = (e: FocusEvent<HTMLInputElement, Element>) => {
    const text = e.target.value;
    if (!text) {
      return;
    }
    const newValue = text.replace(/[^0-9.]+/g, "");
    if (!newValue) return;
    const formatValue = formatByCurrency(
      Number(newValue),
      formatterConfigDefault
    ).replace(symbol, "");
    onChange(Number(newValue).toFixed(2));
    setLocalValue(formatValue);
    onBlur();
  };

  useEffect(() => {
    if (value) {
      return;
    }
    setLocalValue(value);
  }, [value]);

  return (
    <Styles className="NumberInput">
      <p className="NumberInput__symbol">{symbol}</p>
      <TextInput
        {...rest}
        {...restField}
        value={localValue}
        onChange={changeHandler}
        onBlur={blurHandler}
        className="field NumberInput__field"
        label={label}
        maxLength={maxLength}
        errorMessage={errorMessage}
      />
    </Styles>
  );
};

NumberInput.defaultProps = {};

export default NumberInput;
